/**
 * Formats a number by adding a dot separator every three numbers.
 *
 * Example:
 * 2300 -> 2.300
 * 1234567 -> 1.234.567
 * 1234567890 -> 1.234.567.890
 *
 * @param number - The number to format.
 * @returns The formatted number as a string.
 */
export const formatNumber = (number: number): string => {
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
};
